import React from 'react';
import { X } from 'lucide-react';
import { Overlay } from 'components/ui/Overlay';

/**
 * @param {{
 *   open: boolean;
 *   onClose: () => void;
 *   isDark: boolean;
 *   showEnglish: boolean;
 * }} props
 */
export function BhriguQuestionPolicyModal({ open, onClose, isDark, showEnglish }) {
  const panel = isDark
    ? 'border-white/15 bg-gray-950 text-gray-100'
    : 'border-amber-200 bg-white text-gray-900';
  const muted = isDark ? 'text-gray-400' : 'text-gray-600';

  const title = showEnglish ? 'Question policy' : 'प्रश्न नीति';
  const intro = showEnglish
    ? 'AskGuru is for Jyotisha learning on Takshify only - not professional advice.'
    : 'AskGuru केवल Takshify पर ज्योतिष सीखने के लिए है - पेशेवर सलाह नहीं।';

  const cannotItems = showEnglish
    ? [
        'Death, suicide, self-harm, or harm to others',
        'Medical, legal, or financial decisions',
        'Fortune-telling (marriage timing, lottery, exact event dates)',
        'Abuse, hate, or sexual content',
        'Off-topic questions (not Jyotisha learning)',
      ]
    : [
        'मृत्यु, आत्महत्या, आत्म-हानि या दूसरों को नुकसान',
        'चिकित्सा, कानूनी या वित्तीय निर्णय',
        'भविष्यवाणी (विवाह समय, लॉटरी, सटीक तारीखें)',
        'अपशब्द, घृणा या अश्लील सामग्री',
        'विषय से बाहर प्रश्न (ज्योतिष सीखना नहीं)',
      ];

  const strikeNote = showEnglish
    ? 'Questions are saved even when blocked. Repeated violations can lead to suspension and removal.'
    : 'अवरुद्ध होने पर भी प्रश्न सहेजे जाते हैं। बार-बार उल्लंघन पर खाता निलंबित हो सकता है।';

  return (
    <Overlay
      open={open}
      onClose={onClose}
      align="center"
      zIndexClass="z-[120]"
      backdropClassName="bg-black/55 backdrop-blur-[2px]"
      aria-labelledby="bhrigu-policy-title"
    >
      <div className={`relative w-full max-w-md rounded-2xl border p-5 shadow-xl sm:p-6 ${panel}`}>
        <div className="flex items-start justify-between gap-3">
          <h2 id="bhrigu-policy-title" className="text-sm font-bold">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className={`rounded-lg p-1 ${isDark ? 'hover:bg-white/10' : 'hover:bg-gray-100'}`}
            aria-label={showEnglish ? 'Close' : 'बंद करें'}
          >
            <X className="h-4 w-4" aria-hidden />
          </button>
        </div>
        <p className={`mt-2 text-xs leading-relaxed ${muted}`}>{intro}</p>
        <p className={`mt-3 text-[11px] font-bold uppercase tracking-wide ${muted}`}>
          {showEnglish ? 'Do not ask about' : 'इन पर प्रश्न न करें'}
        </p>
        <ul className={`mt-1.5 list-disc space-y-1 pl-4 text-xs leading-relaxed ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
          {cannotItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className={`mt-3 text-[10px] leading-relaxed ${muted}`}>{strikeNote}</p>
      </div>
    </Overlay>
  );
}

export default BhriguQuestionPolicyModal;
